import { ApiService } from './index'
import { Dashboard, ApiResponse } from '@types'

export const dashboardsApi = {
  getDashboards: () =>
    ApiService.get<ApiResponse<Dashboard[]>>('/dashboards/dashboards/'),
  getDashboard: (id: number) =>
    ApiService.get<ApiResponse<Dashboard>>(`/dashboards/dashboards/${id}/`),

  createDashboard: (data: Partial<Dashboard>) =>
    ApiService.post<ApiResponse<Dashboard>>('/dashboards/dashboards/', data),

  updateDashboard: (id: number, data: Partial<Dashboard>) =>
    ApiService.patch<ApiResponse<Dashboard>>(`/dashboards/dashboards/${id}/`, data),

  deleteDashboard: (id: number) =>
    ApiService.delete(`/dashboards/dashboards/${id}/`),

  getDashboardData: (id: number, params?: {
    start?: string
    end?: string
    interval?: string
  }) =>
    ApiService.get<ApiResponse<any>>(`/dashboards/dashboards/${id}/data/`, { params }),

  shareDashboard: (id: number, data: { emails: string[]; message?: string }) =>
    ApiService.post<ApiResponse<{ message: string }>>(`/dashboards/dashboards/${id}/share/`, data),

  exportDashboard: (id: number, format: 'pdf' | 'png' | 'csv') =>
    ApiService.get(`/dashboards/dashboards/${id}/export/`, {
      params: { format },
      responseType: 'blob'
    }),
}
